import { useAuth } from "../../../context";
import { useMutation, useQuery } from "react-query";
import adminApi from "../../../api/esg-admin/adminApi";
import { OrganizationAdministration } from "../../../api";

export const esgAdminKeys = {
  orgs: () => ["orgs"],
  orgModules: () => ["orgModules"],
};

export const useGetAllOrganizations = (config) => {
  const { callApi } = useAuth();
  return useQuery(esgAdminKeys.orgs(), () => callApi(adminApi.getAllOrgs), config);
};

export function useUpdateOrgModules(config) {
  const { callApi } = useAuth();
  return useMutation((data) => callApi(adminApi.updateOrgModules, data), config);
}

export function useCreateOrg(config) {
  const { callApi } = useAuth();
  return useMutation((data) => callApi(adminApi.createOrg, data), config);
}

export function useGetOrganizationModules(config) {
  const { callApi } = useAuth();
  return useQuery(
    ...esgAdminKeys.orgModules(),
    () => callApi(OrganizationAdministration.getOrganizationStructure),
    config
  );
}
